import { useId } from "react";
import { FieldHint, FieldLabel, INPUT_CLASS, fieldClass, fieldTone } from "./Field";

/*
  Figma "Text field". `error` replaces the hint with a red line that says how
  to fix it; `success` turns the outline and hint green.
*/
const TextField = ({ label, hint, error, success = false, icon = null, disabled = false, id, className = "", ...inputProps }) => {
  const autoId = useId();
  const inputId = id || autoId;
  const tone = fieldTone({ error, success });
  const message = error || hint;

  return (
    <div className={`flex w-full flex-col gap-[6px] ${className}`}>
      {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
      <div className={fieldClass({ tone, disabled, className: "gap-space-8 px-space-16" })}>
        {icon && <span className="flex size-5 shrink-0 items-center justify-center text-label-secondary">{icon}</span>}
        <input
          id={inputId}
          disabled={disabled}
          aria-invalid={error ? true : undefined}
          aria-describedby={message ? `${inputId}-hint` : undefined}
          className={INPUT_CLASS}
          {...inputProps}
        />
      </div>
      {message && (
        <FieldHint id={`${inputId}-hint`} tone={tone}>
          {message}
        </FieldHint>
      )}
    </div>
  );
};

export default TextField;
